import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useHistory,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import jwt_decode from "jwt-decode";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import AdminLayout from "layouts/Admin";
import { BASE_URL, SCHOOL_INFO } from "utils/constants";
import { setPermissions } from "./store/actions/auth.actions";
import Socket, { initConeection } from "./components/Socket/Socket"
import { setTokenExpiration } from './utils/auth-refresh'
import { useRef } from "react";
axios.defaults.withCredentials = true;
if (window.location !== window.parent.location) {
  axios.defaults.headers.common["iframe"] = true;
}

let hasShownBlockedAlert = false;
const handleBlockedStudent = (msg) => {
  if (hasShownBlockedAlert) return;
  hasShownBlockedAlert = true;
  Cookies.remove("studentportaltoken");
  localStorage.removeItem("token");
  Swal.fire({
    icon: "error",
    title: "Account Blocked",
    text: msg || "Your account has been blocked. Please contact the school administration.",
    allowOutsideClick: false,
    allowEscapeKey: false,
    confirmButtonText: "OK",
  }).then((result) => {
    if (result.isConfirmed) {
      window.location.replace(`${BASE_URL}/login.php?blocked=1`);
    }
  });
};

axios.interceptors.response.use(
  (response) => {
    if (response?.data?.status === "blocked") {
      handleBlockedStudent(response?.data?.msg);
      return new Promise(() => {});
    }
    return response;
  },
  (error) => {
    if (
      error?.response?.data?.status === "blocked" ||
      (error?.response?.status === 403 &&
        error?.response?.data?.msg &&
        error.response.data.msg.toLowerCase().includes("blocked"))
    ) {
      handleBlockedStudent(error?.response?.data?.msg);
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

const App = () => {
  const dispatch = useDispatch();
  const [isAuth, setIsAuth] = useState(false);
  const permissions = useSelector((state) => state.permissions);
  const mySwal = withReactContent(Swal);
  const history = useHistory();

  const adjustColorBrightness = (col, amt) => {
    if (!col) return "";
    let usePound = false;

    if (col[0] === "#") {
      col = col.slice(1);
      usePound = true;
    }

    let num = parseInt(col, 16);
    let r = (num >> 16) + amt;
    if (r > 255) r = 255;
    else if (r < 0) r = 0;

    let b = ((num >> 8) & 0x00ff) + amt;
    if (b > 255) b = 255;
    else if (b < 0) b = 0;

    let g = (num & 0x0000ff) + amt;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;

    let result = (g | (b << 8) | (r << 16)).toString(16);
    while (result.length < 6) result = "0" + result;

    return (usePound ? "#" : "") + result;
  };

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${BASE_URL}/theme/get.php`);
        const currentTheme = res.data.data;
        if (currentTheme) {
          document.documentElement.style.setProperty("--theme-primary-color", currentTheme.primary_color);
          document.documentElement.style.setProperty("--theme-secondary-color", currentTheme.secondary_color);
          document.documentElement.style.setProperty("--theme-accent-color", currentTheme.accent_color);
          document.documentElement.style.setProperty("--theme-header-text-color", currentTheme.header_text_color);
          document.documentElement.style.setProperty("--theme-text-color", currentTheme.text_color);
          document.documentElement.style.setProperty("--theme-background-p-color", currentTheme.background_p_color);
          document.documentElement.style.setProperty("--theme-background-s-color", currentTheme.background_s_color);
          document.documentElement.style.setProperty("--theme-border-color", adjustColorBrightness(currentTheme.primary_color, -20));
          document.documentElement.style.setProperty("--theme-secondary-color-dark", adjustColorBrightness(currentTheme.secondary_color, -10));
          document.documentElement.style.setProperty("--theme-accent-color-dark", adjustColorBrightness(currentTheme.accent_color, -10));
        }
      } catch (error) {
        console.error("Error fetching theme", error);
      }
    })();
  }, []);

  useEffect(() => {
    const updateFavicon = () => {
      if (SCHOOL_INFO?.logo) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.getElementsByTagName('head')[0].appendChild(link);
        }
        link.href = SCHOOL_INFO.logo;
      } else {
        setTimeout(updateFavicon, 100);
      }
    };
    updateFavicon();
  }, []);

  useEffect(() => {
    (async () => {
      const token = Cookies.get("studentportaltoken");
      let decodedToken = {};

      try {
        if (token) {
          localStorage.setItem("token",token);
          setIsAuth(true);
          // initConeection( SOCKET_URL , token );
          decodedToken = jwt_decode(token || "");
          setTokenExpiration(decodedToken)
          let res = null;
          if (window.location !== window.parent.location) {
            // axios.defaults.headers.common['iframe'] = true;
            res = await axios.post(`${BASE_URL}/auth/login.php`, {
              username: decodedToken.data.user.ivyemail,
            });

          } else {
            res = await axios.post(`${BASE_URL}/auth/updateroles.php`, {
              username: decodedToken.data.user.ivyemail,
            });
          }

          if (res?.data?.status === "blocked") {
            handleBlockedStudent(res?.data?.msg);
            return;
          }

          if (res?.data?.data != null) {
            localStorage.setItem("token",res.data.data);
            decodedToken = jwt_decode(res.data.data || "");
            setTokenExpiration(decodedToken)

            dispatch(setPermissions({ ...decodedToken.data.user }));
          } else {
            RedirectToLogin();
          }
          return;
        }

        axios
          .post(`${BASE_URL}/auth/login.php`)
          .then((response) => {
            if (response?.data?.status === "blocked") {
              handleBlockedStudent(response?.data?.msg);
              return;
            }

            if (response.data.data) {
              setIsAuth(true);
              const token = response.data.data;
              // initConeection( SOCKET_URL , token );
              Cookies.set("studentportaltoken", token);
              localStorage.setItem("token",token);
              decodedToken = jwt_decode(token);
              setTokenExpiration(decodedToken)

              dispatch(setPermissions({ ...decodedToken.data.user }));
              setIsAuth(true);

            } else {
              RedirectToLogin();
            }
          })
          .catch((error) => {
            if (error?.response?.data?.status === "blocked") {
              handleBlockedStudent(error?.response?.data?.msg);
              return;
            }
            RedirectToLogin();
          });
      } catch (err) {
        if (err?.response?.data?.status === "blocked") {
          handleBlockedStudent(err?.response?.data?.msg);
          return;
        }
        Swal.fire("Something went wrong!", "", "error");
      }
    })();
  }, []);

  // alert when student has quizzes

  useEffect(async () => {

    let res = await axios.get(`${BASE_URL}/exam/getstudentexams.php`);

    if (res.data.data.exams.length > 50) {
      mySwal.fire({
        html: (
          <>
            <ul className="fs-6 fw-bold w-100 mb-5">
              {res.data.data.exams.length > 0 &&
                res.data.data.exams.map((exam, key) => {
                  return (
                    <li key={key}>
                      {/* {`${examLink}${exam.id}`} */}
                      <a href={exam.examlink} target="_blank">
                        Go To {exam.coursename} Quizz --&gt;&gt;{" "}
                        {exam.examname}
                      </a>
                    </li>
                  );
                })}
            </ul>
          </>
        ),
        title: "You have to finish quizzes",
        icon: "warning",
        iconHtml: "!",
        showConfirmButton: false,
        allowOutsideClick: false,
      });
      //clearInterval(periodicCheck)
    } else if (res.data.data.surveys.length > 50) {
      mySwal.fire({
        html: (
          <>
            <ul className="fs-6 fw-bold w-100 mb-5">
              {res.data.data.surveys.length > 0 &&
                res.data.data.surveys.map((survey, key) => {
                  return (
                    <li key={key}>
                      {/* {`${examLink}${exam.id}`} */}
                      <a href={survey.link} target="_blank">
                        Go To {survey.subject}
                      </a>
                    </li>
                  );
                })}
            </ul>
          </>
        ),
        title: "You have to finish quizzes",
        icon: "warning",
        iconHtml: "!",
        showConfirmButton: false,
        allowOutsideClick: false,
      });
      //clearInterval(periodicCheck)
    } else {
    }

  }, []);

  // ------------------------------

  const RedirectToLogin = () => {
    window.location.replace(`${BASE_URL}/login.php`);
  };
  const mytopEle = useRef(null)

  function scrollToTop() {
    if (mytopEle.current !== null) {
      mytopEle.current.scrollIntoView({ behavior: "smooth" });
    }
  }

  return (
    <div className="App" id="wrapper">
      <div id="topelement" />
      <Router>
        <Socket />
        <Switch>
          <Route
            exact
            path="/"
            render={() => {
              return isAuth == true && <Redirect to="/home" />;
            }}

          />
          <AdminLayout />
        </Switch>
      </Router>
    </div>
  );
};

export default App;
